export enum TabDisplayStyle {
  Accordion = "Accordion",
  Normal = "Normal",
  Separate = "Separate",
  AccordionHeaderTab = "AccordionHeaderTab",
  AccordionChildren = "AccordionChildren"
}